// extracted by mini-css-extract-plugin
export default {"content":"style_content__a542h","itemName":"style_itemName__S2Bhr"};